module.exports = __webpack_public_path__ + "img/spain-logo-icon.195ebf39.png";